import type {
  CheckboxOption,
  ExtendedCheckboxOptions
} from './EhsFormioCheckboxGroup';

export function findSelectOption(
  searchedSelectValue: string,
  translatedItems: ExtendedCheckboxOptions[]
): CheckboxOption | undefined {
  const foundOption = translatedItems.find(
    option => option.selectValue === searchedSelectValue
  );

  if (!foundOption) {
    return undefined;
  }

  return {
    selectLabel: foundOption.selectLabel,
    selectValue: foundOption.selectValue
  };
}

export function isArrayOfStrings(
  value?: string | string[] | CheckboxOption[] | null
): value is string[] {
  if (!value || typeof value === 'string') {
    return false;
  }

  return (
    Array.isArray(value) &&
    (value as unknown[]).every(val => typeof val === 'string')
  );
}

export function isArrayOfCheckboxOptions(
  value?: string | string[] | CheckboxOption[] | null
): value is CheckboxOption[] {
  if (
    !Array.isArray(value) ||
    value.some((val: string | CheckboxOption) => typeof val === 'string')
  ) {
    return false;
  }

  return (value as CheckboxOption[]).every(
    (val: CheckboxOption) =>
      typeof val === 'object' && val !== null && 'selectValue' in val
  );
}

export function transformDefaultValuesToCheckboxOptions(
  defaultValue: string[],
  translatedItems: ExtendedCheckboxOptions[]
): CheckboxOption[] {
  const defaultCheckboxGroupValue: CheckboxOption[] = [];
  for (const value of defaultValue) {
    const match = translatedItems.find(option => option.selectValue === value);
    if (match) {
      defaultCheckboxGroupValue.push({
        selectLabel: match.selectLabel,
        selectValue: match.selectValue
      });
    }
  }
  return defaultCheckboxGroupValue;
}

export function updateCheckboxGroupValue(
  value: CheckboxOption[],
  selectValue: string
): CheckboxOption[] {
  return value.filter(val => val.selectValue !== selectValue);
}
